/*
  Trust row auto-fit.

  These rows have to hold merchant-written text of any length on a single line.
  Three fixed approaches were tried and all of them lose: equal columns clip with
  an ellipsis, wrapping stacks the badges into a block, and a scrolling row hides
  the last one off the edge.

  So the row measures itself instead. It shrinks its own type and gaps just far
  enough that everything fits on one line, and stops at a legibility floor. Only
  if it still does not fit at that floor does it fall back to scrolling, which by
  then means the labels are genuinely too long for the space.
*/
(function () {
  var SELECTOR = '.cd-trust, .pdp-trust';
  var FLOOR = 0.72;
  var STEP = 0.04;

  function fit(row) {
    if (!row || !row.isConnected) return;

    // Always remeasure from full size, or a row that grew would stay shrunk.
    row.style.setProperty('--trust-fit', '1');
    row.style.setProperty('--trust-gap-fit', '1');
    if (row.scrollWidth <= row.clientWidth) return;

    var scale = 1;
    while (scale > FLOOR) {
      scale -= STEP;
      row.style.setProperty('--trust-fit', String(scale.toFixed(2)));
      row.style.setProperty('--trust-gap-fit', String((scale * scale * scale).toFixed(3)));
      if (row.scrollWidth <= row.clientWidth) return;
    }
    // Floor reached and still overflowing; leave it scrollable rather than
    // shrinking the text past the point of being readable.
  }

  function fitAll() {
    document.querySelectorAll(SELECTOR).forEach(fit);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fitAll();
    });
  }

  if (window.ResizeObserver) {
    var observer = new ResizeObserver(schedule);
    var observed = new WeakSet();
    var attach = function () {
      document.querySelectorAll(SELECTOR).forEach(function (row) {
        if (observed.has(row)) return;
        observed.add(row);
        observer.observe(row);
      });
    };
    attach();
    // The cart drawer replaces its own markup after every add, so new rows
    // have to be picked up as they appear.
    new MutationObserver(function () {
      attach();
      schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
  } else {
    window.addEventListener('resize', schedule);
  }

  // Web fonts land after first paint and change every measurement.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  schedule();
})();
